
var $ = jQuery;
let swiperDailyProduct = new Swiper(".daily-product--carousel", {
  slidesPerView: 4.3,
  spaceBetween: 15,
  keyboard: true,
  pagination: {
    el: '.daily-product-carousel-pagination',
    clickable: true,
  },
   mousewheel: {
    forceToAxis: true
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    }
  },
});

let swiperExperience = new Swiper(".real-experience--slider", {
  slidesPerView: 4.3,
  spaceBetween: 15,
  keyboard: true,
  navigation: {
    nextEl: '.real-experience--next',
    prevEl: '.real-experience--prev',
  },
   mousewheel: {
    forceToAxis: true
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 1.3,
    },
    768: {
      slidesPerView: 2.5,
    },
    1024: {
      slidesPerView: 4.3,
    }
  },
});

let swiper = new Swiper(".product-recommendation-slider", {
  slidesPerView: 6,
  spaceBetween: 15,
  grabCursor: true,
  keyboard: true,
  mousewheel: {
    forceToAxis: true
  },
  pagination: {
    el: '.product-recommendation--pagination',
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 2.2,
    },
    768: {
      slidesPerView: 2.5,
    },
     991: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 6,
    },
  },
});

$(function () {
  var galleryThumbs = new Swiper(".gallery-thumbs", {
    centeredSlides: true,
    centeredSlidesBounds: true, 
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      480: {
        direction: "vertical",
        slidesPerView: 5
      }
    }
  });
let swiperProductGallery = new Swiper(".product-gallery-carousel", {
  slidesPerView: 1,
  spaceBetween: 15,
  grabCursor: true,
  keyboard: true,
  mousewheel: {
    forceToAxis: true
  },
  pagination: {
    el: '.product-gallery--pagination',
    clickable: true,
  },
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
  thumbs: {
      swiper: galleryThumbs
    }
});
 swiperProductGallery.on("slideChangeTransitionStart", function () {
    galleryThumbs.slideTo(swiperProductGallery.activeIndex);
  });
  galleryThumbs.on("transitionStart", function () {
    swiperProductGallery.slideTo(galleryThumbs.activeIndex);
  });
});

$(function () {
  var IngrediNumbers = new Swiper(".ingredi-numbers-carousel", {
    centeredSlides: true,
    centeredSlidesBounds: true, 
    direction: "horizontal",
    spaceBetween: 0,
    slidesPerView: 4,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    breakpoints: {
      200: {
        slidesPerView: 1.7,
      },
      768: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: 4.4,
      }
    },
  });
   var swiperIngredientProduct = new Swiper(".ingredient-carousel", {
    slidesPerView: 4,
    spaceBetween: 15,
    keyboard: true,
    // pagination: {
    //   el: '.ingredient-carousel-pagination',
    //   clickable: true,
    //   type: 'bullets',
    // },
     mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      200: {
        slidesPerView: 1.7,
      },
      768: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: 4.4,
      }
    },
  });
  swiperIngredientProduct.on("slideChangeTransitionStart", function () {
    IngrediNumbers.slideTo(swiperIngredientProduct.activeIndex);
  });
  IngrediNumbers.on("transitionStart", function () {
    swiperIngredientProduct.slideTo(IngrediNumbers.activeIndex);
  });
});



 $('[data-diff]').simpleImageDiff({
    resize: false,
    width: 800,
    titles: {
        before: 'before',
        after: 'after'
    },
    maxWidth: 2000
});

$(document).on('click', '.play-gif', function () {
  $('.play-gif').not(this).show();
  $(this).hide();
  var video = $(this).siblings('.customer_vid');
  $('.customer_vid').not(video).trigger('pause');
  video.trigger('play');
});
$(document).on('click', '.customer_vid', function () {
  $(this).siblings('.play-gif').show();
  $(this).trigger('pause');
});
// Before After Image JS
$(".image--wrapper").on({
  input: function(e) {
    updateImage(e.target.value, e.target);
  },
  change: function(e) {
    updateImage(e.target.value, e.target);
  },
  touchstart: function(e) {
    // Check if the touch event originated from within the slider
    if ($(e.target).closest('input[type="range"]').length === 0) {
      e.preventDefault();
    }
  },
  touchmove: function(e) {
    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
    var slider = $(this).find('input[type="range"]');
    var newValue = calculateNewValue(touch.pageX, slider);
    slider.val(newValue).trigger('input');
  }
});

function updateImage(sliderPos, target) {
  var parent = $(target).parent();
  var imageShow = parent.find('.foreground-img');
  var sliderArrow = parent.find('.slider-button');
  imageShow.css('width', `${sliderPos}%`);
  sliderArrow.css('left', `calc(${sliderPos}% - 18px)`);
}

function calculateNewValue(touchX, slider) {
  var sliderWidth = slider.width();
  var offsetX = touchX - slider.offset().left;
  var percentage = (offsetX / sliderWidth) * 100;
  
  // Ensure the percentage is within the valid range
  percentage = Math.min(100, Math.max(0, percentage));

  return percentage;
}

// Header fixed Js
$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  if (scroll >= 100) {
    $(".navbar").addClass("fixed-navbar");
  } else {
    $(".navbar").removeClass("fixed-navbar");
  }
});

if ($(window).width() <= 991) {
  $(".dropdown span").on("click", function () {
    var ab = $(this).parent();
    $(ab).find(".dropdown-menu").toggleClass("show");
  });
}

$(document).ready(function () {
  jQuery("button.navbar-toggler .navbar-toggler-icon").click(function () {
    jQuery(this)
      .parents(".navbar")
      .find(".navbar-collapse")
      .addClass("collapse-toggled");
  });
  jQuery(".navbar-collapse .button-close").click(function () {
    jQuery(this)
      .parents(".navbar")
      .find(".navbar-collapse")
      .removeClass("collapse-toggled show");
    
  });
  
  $(".product #select-value").on("click", function(){
      $('.product').toggleClass('dropdown--open');
  });
  $(".product .nav-link ").on( "click", function(e){
      $('.product').removeClass('dropdown--open');
      var selectValue = e.target.innerText;
      $('.product #select-value')[0].innerHTML = selectValue;
  });
});



// for  video  carousel section in press page
let swiperVideoCaro = new Swiper(".video-carousel, .blog-carousel", {
  slidesPerView: 2,
  spaceBetween: 15,
  keyboard: true,
  mousewheel: {
    forceToAxis: true
  },
  navigation: {
    nextEl: '.video-carousel--next',
    prevEl: '.video-carousel--prev',
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 2,
    }
  },
});


// for adding red class in video carousel section
    $(".press-content p:nth-child(4)").addClass("red");
 

// for blog section in press page
let swiperBlog = new Swiper(".blog-carousel", {
  slidesPerView: 2,
  spaceBetween: 15,
  keyboard: true,
  mousewheel: {
    forceToAxis: true
  },
  navigation: {
    nextEl: '.blog-carousel--next',
    prevEl: '.blog-carousel--prev',
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 2,
    }
  },
});

// single product js start
$(document).ready(function () {
  jQuery(".option-radios").on("change", function () {
    var rc_val = $('.rc_widget__option__input:checked').val();
    $('.rc_widget__option__input:checked').prop('checked', false);
    setTimeout(function () {
      set_variant();
      $('.rc_widget__option__input[value="'+rc_val+'"]').prop('checked', true).trigger("click");
      $('.rc_widget__option__input[value="'+rc_val+'"]').change();
    }, 100);
  });

  function set_variant() {
    var newar = [$(".option-radios:checked").val()];
    if (newar.length > 0) {
      var thisvals = newar.join(" / ");
      jQuery(".product-form__variants").find("option").each(function () {
        if ($(this).data("title") == thisvals) {
          $('#product_variant_id').val($(this).val());
        }
      });
    }
  }
});


function incrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal)) {
    parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}
function decrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal) && currentVal > 0) {
    parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}
  $('.input-group').on('click', '.button-plus', function(e) {
    incrementValue(e);
  });
  $('.input-group').on('click', '.button-minus', function(e) {
    decrementValue(e);
  });

$(document).ready(function(){
    
  $('.key-feature .tab-key .key a').on('mouseenter', function () {
      var $this = $(this);
  $('.container .content-tab p').removeClass('active'); 
        $('.key-feature .tab-key .key').removeClass('icon_class');
    var x =  $this.attr('href');
    var newwar = $this.parent('.key').addClass('icon_class');
          
     var y =  $this.parents('.parent').find('.content-of-key');
      y.each(function() {
    var z =  $(this).attr('id');
          if (z == x) {
             
                  $(this).addClass('active');
             
          }else{
          }
       });
  });
 });
$(document).ready(function () {
  $('.count-up p').addClass('counter-count');
  $('.counter-count').each(function () {
    $(this).prop('Counter', 0).animate({
      Counter: $(this).text()
    }, 
    {
      duration: 4000,
      easing: 'swing',
      step: function (now) {
        $(this).text(Math.ceil(now));
      }
    });
  });
});

$(document).ready(function(){
  $(".press-content p:nth-child(4)").addClass("red");
});


// Pricing table - mobile only slider
var init = false;
var pricingCardSwiper;
function swiperCard() {
  if (window.innerWidth <= 767) {
    if (!init) {
      init = true;
      pricingCardSwiper = new Swiper(".card_img_wrapper", {
        slidesPerView: 1.1,
        spaceBetween: 10,
        grabCursor: true,
        keyboard: true,
        autoHeight: false,
         mousewheel: {
          forceToAxis: true
        },
        pagination: {
          el: '.card_img_wrapper-pagination',
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.1,
          }
        },
      });
    }
  } else if (init) {
    pricingCardSwiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);



var btn_offset = $('.add-to-cart-group').offset().top/2;
$(window).scroll(function() {
  if ($(window).width() < 767) {
    if($(this).scrollTop() > btn_offset) {
      $('.add-to-cart-group').addClass('sticky_atc');
    }else{
      $('.add-to-cart-group').removeClass('sticky_atc');
    }
  }
});  

// varun-js-start
let swiperDietProduct = new Swiper(".diet-carousel", {
  slidesPerView: 6.1,
  spaceBetween: 10,
  keyboard: true,
  pagination: {
    el: '.diet-carousel-pagination',
    clickable: true,
  },
   mousewheel: {
    forceToAxis: true
  },
  breakpoints: {
    200: {
      slidesPerView: 4.3,
    },
    768: {
      slidesPerView: 5.2,
    },
    1024: {
      slidesPerView: 6.1,
    }
  },
});

let swiperPairProduct = new Swiper(".pair-carousel", {
  slidesPerView: 3,
  spaceBetween: 10,
  keyboard: true,
  pagination: {
    el: '.pair-carousel-pagination',
    clickable: true,
  },
   mousewheel: {
    forceToAxis: true
  },
  breakpoints: {
    200: {
      slidesPerView: 2.2,
    },
    768: {
      slidesPerView: 2.5,
    },
    1024: {
      slidesPerView: 3,
    }
  },
});


// varun-js-end

$(document).on('click', '.scrollBtn', function(e){
  e.preventDefault();
  var scrollToEl = $(this).attr('href');
  $('html').animate({scrollTop: $(scrollToEl).offset().top - 100,}, 1000);
});





